import React, { useEffect } from "react";
import { connect } from "react-redux";
import { getGradeList } from "../../actions/Grade.action";
import AddWeeklyFilesForm from "../../components/AddWeeklyFilesForm/AddWeeklyFilesForm";
import Layout from "../../components/shared/Layout/Layout";

const AddWeeklyFilePage = ({ grades, getGradeList }) => {
  useEffect(() => {
    getGradeList();
  }, []);
  return (
    <div className="bg_light">
      <Layout title={`Add Weekly Assessment`}>
        <AddWeeklyFilesForm grades={grades} />
      </Layout>
    </div>
  );
};

const mapStateToProps = (state) => ({
  grades: state.grade.grade,
});

export default connect(mapStateToProps, { getGradeList })(AddWeeklyFilePage);
